module.exports = __webpack_public_path__ + "img/javaTTT.174284b7.jpg";